import type { DashboardSection } from './dashboard.js';

export const loadProjectsHomeLayout = () => import('../../layouts/ProjectsHomeLayout.js');
export const loadDashboardLayout = () => import('../../layouts/DashboardLayout.js');
export const loadSettingsLayout = () => import('../../layouts/SettingsLayout.js');
export const loadGlobalSettingsLayout = () => import('../../layouts/GlobalSettingsLayout.js');
export const loadInsightsLayout = () => import('../../layouts/InsightsLayout.js');

export const loadDashboardConfigPage = async () =>
  import('../../components/Dashboard/DashboardConfigPage.js').then((mod) => ({
    default: mod.DashboardConfigPage,
  }));

export const loadDashboardSchedulePage = async () =>
  import('../../components/Dashboard/DashboardSchedulePage.js').then((mod) => ({
    default: mod.DashboardSchedulePage,
  }));

export const loadDashboardSyncPage = async () =>
  import('../../components/Dashboard/DashboardSyncPage.js').then((mod) => ({
    default: mod.DashboardSyncPage,
  }));

export const protectedLayoutChunkLoaders = [
  loadProjectsHomeLayout,
  loadDashboardLayout,
  loadSettingsLayout,
  loadGlobalSettingsLayout,
  loadInsightsLayout,
] as const;

export function preloadDashboardSectionChunk(section: DashboardSection): Promise<unknown> {
  if (section === 'config') {
    return loadDashboardConfigPage();
  }

  if (section === 'schedule') {
    return loadDashboardSchedulePage();
  }

  return loadDashboardSyncPage();
}
